import React, { useState, useEffect } from "react";
import FileViewer from "react-file-viewer";

import { Icon, Modal, notification } from "antd";
import { documentService } from "services";

const urlCreator = window.URL || window.webkitURL;
const ErrorComponent = (props) => (
  <p>Une erreur est survenue dans le chargement de ce fichier...</p>
);

export function previewDocument(doc, modalProps) {
  var m = Modal.info({
    content: <Icon type="loading" spin style={{ display: "block", fontSize: "52px" }} />,
    maskClosable: true,
    okButtonProps: { style: { display: "none" } },
    ...modalProps,
  });

  documentService.get(doc.id).then((blob) => {
    m.update({
      content: (
        <FileViewer
          fileType={doc.extension.split("/")[1] || ""}
          filePath={urlCreator.createObjectURL(blob)}
          errorComponent={ErrorComponent}
          unsupportedComponent={ErrorComponent}
        />
      ),
    });
  });
  return m;
}

export const Signature = (props) => {
  const [img, setImg] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      const blob = await documentService.get(props.doc.id);
      setImg(blob);
    };

    fetchImage();
  }, []);

  return img ? (
    <img src={urlCreator.createObjectURL(img)} onClick={() => previewDocument(props.doc)} />
  ) : (
    <></>
  );
};
